export enum FieldOrigin {
  LoanStructure = 'LoanStructure',
  BorrowerInformation = 'BorrowerInformation',
  PropertyInformation = 'PropertyInformation',
  CustomInformation = 'CustomInformation',
  AssetLiability = 'AssetLiability',
  TrackRecord = 'TrackRecord',
  DeclarationsHMDA = 'DeclarationsHMDA',
  AdditionalMember = 'additionalMember',
  Other = 'Other',
  Custom = 'Custom',
  ManageAccount = 'ManageAccount',
}

export const isCustomOrigin = (fieldOrigin: FieldOrigin | string) =>
  fieldOrigin.startsWith(FieldOrigin.CustomInformation)

export const fieldOriginOptions: Record<FieldOrigin, string> = {
  [FieldOrigin.LoanStructure]: 'Loan Structure',
  [FieldOrigin.BorrowerInformation]: 'Borrower Information',
  [FieldOrigin.PropertyInformation]: 'Property Information',
  // [FieldOrigin.CustomInformation]: 'Custom Information',
  [FieldOrigin.AssetLiability]: 'Asset & Liability',
  [FieldOrigin.TrackRecord]: 'Track Record',
  [FieldOrigin.AdditionalMember]: 'Additional Entity Members',
  [FieldOrigin.DeclarationsHMDA]: 'Declarations & HMDA',
  [FieldOrigin.Other]: 'Other',
  [FieldOrigin.Custom]: 'Custom',
  [FieldOrigin.ManageAccount]: 'Manage Account',
} as any

export const fieldOriginForVisibility = [FieldOrigin.ManageAccount]

export interface IVisibleLogic {
  fieldOrigin: FieldOrigin
  fieldKey: string
  value: string | number | boolean
}

export interface ILoanFieldPos {
  fieldOrigin: FieldOrigin
  fieldKey: string
  [x: string]: any
}

export interface ISelectRangeOption {
  title: string
  from: number
  to?: number
  chapter?: number
  days?: number
  months?: number
  visible?: boolean
}

export interface ISelectValueOption {
  title: string
  value: number
  subValue?: string
  visible?: boolean
}

export interface IVisibleProp {
  title?: string
  inputType?: string
  type?: string
  section?: string
  tooltip?: string
  defaultValue?: any
  visible?: boolean
  required?: boolean
  coborrowerRequired?: boolean
  visibleLogic?: IVisibleLogic[][]
  visibleAccountTypes?: Record<string, boolean>
  visibleLoanTypes?: Record<string, boolean>
  options?: ISelectRangeOption[] | ISelectValueOption[]
  selectedOptions?: string[]
  linkToParty?: { isActive: boolean; type: string; input: string }
}

export interface ILoanOriginSection {
  id: number
  title?: string
  fields: string[]
}

export type LoanFieldProps = {
  // [P in FieldOrigin]: Record<string, IVisibleProp>
  [x: string]: Record<string, IVisibleProp>
} & {
  sections?: {
    [T in FieldOrigin]?: ILoanOriginSection[]
  }
  order?: FieldOrigin[]
  customTitle?: Record<FieldOrigin, string>
  visibility?: Record<FieldOrigin, string>
  properties?: Record<
    FieldOrigin,
    {
      accountTypes: Record<string, boolean>
      visibleLoanTypes: Record<string, boolean>
      visibleByBorrower: Record<string, boolean>
    }
  >
}
